<template>
    <v-layout ref="idMyQuickLink" row wrap class="my-quick-links inner-scrollbar" v-click-outside="scrollDefaultState">
        <status-overlay :action="loadingAction" content-height="100px"></status-overlay>
        <v-flex class="quicklink_v-flex" xs4 text-xs-center v-for="(quickLink, index) in myQuickLinks" :key="index">
            <v-tooltip top>
                <img
                    @click="gotoMyQuickLink(quickLink)"
                    :class="isHivebriteRedirectCommunity(quickLink) && `HB_redirect_community`"
                    class="quicklink_img"
                    :src="sizeFormattedImageUrl(quickLink.iconUrl, 150, 150)"
                    :alt="quickLink.name"
                    :data-qe-id="'quickLink_' + index"
                    slot="activator"
                />
                <span :data-qe-id="'quickLink_name' + index">{{ quickLink.name }}</span>
                <span class="my-quick-links__chapterName" slot="activator" :data-qe-id="'quickLink_name1' + index">{{
                    quickLink.name
                  }}</span>
            </v-tooltip>
            <span class="my-quick-links__chapterLabel" :data-qe-id="'quickLink_label' + index">{{
                quickLinkLabel(quickLink)
            }}</span>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { storeAction } from '../../../store/storeActions.constant';
import { storeGetters } from '../../../store/storeGetters.constant';
import { myToolsConstants } from '../mytools.constant.js';
import ClickOutside from 'vue-click-outside';
import StatusOverlay from '../../StatusOverlay/StatusOverlay';
import { gaDataLayerEvent } from '../../../plugins/analytics';
import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
    name: 'MyQuickLinks',
    components: { StatusOverlay },
    data: () => ({
        myToolsConstants,
        sizeFormattedImageUrl,
    }),
    methods: {
        isHivebriteRedirectCommunity(quickLink) {
          return !!getHbRedirectByCommunityId(this.connectPlusRedirects, quickLink.communityId);
        },
        gotoMyQuickLink(quickLink) {
            gaDataLayerEvent(gtmEventName.C_Quick_Link, quickLink.name);

            let url = quickLink.hyperLink;
            if (url && !url.includes('http')) {
                url = `http://${url}`;
            }

          const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, quickLink.communityId);
          if (hbRedirectCommunity) {
            window.open(hbRedirectCommunity.redirectUrl, '_self');
          } else {
            const appOrigin = window.location.origin;
            if (url.includes(appOrigin) || this.isMobileAppBrowser) {
              window.open(url, '_self');
            } else {
              window.open(url, '_blank');
            }
          }
        },
        scrollDefaultState() {
            this.$refs.idMyQuickLink.scrollTop = 0;
        },
        quickLinkLabel(quickLink) {
            return quickLink.label === this.myToolsConstants.QUICK_LINKS.Resource
                ? ''
                : `${this.myToolsConstants.QUICK_LINKS.My} ${quickLink.label}`;
        },
    },
    directives: {
        ClickOutside,
    },
    computed: {
        ...mapState('actionState', ['actions']),
        ...mapGetters({
            myQuickLinks: `tools/${storeGetters.myQuickLinks}`,
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
        }),
        loadingAction() {
            return this.actions[storeAction.getMyQuickLinks];
        },
    },
};
</script>

<style lang="scss">
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

.my-quick-links {
    max-height: 345px;
    min-height: 100px;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    word-wrap: break-word;

    &__chapterName {
        font-size: 12px;
        line-height: normal;
        text-align: center;
        display: block;
        margin-bottom: 0px;
        padding: 0 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    &__chapterLabel {
        color: $ypo-gray;
        font-size: 10px;
        line-height: normal;
        text-align: center;
        display: block;
    }
}

.quicklink_img {
    cursor: pointer;
    width: 54px;
    height: 54px;
    border-radius: 50px;
    background-color: rgba($ypo_blue, 0.6);
    box-shadow: inset 0 1px 3px 0 rgba($black, 0.5), 0 0 0 0 rgba($black, 0.5);
    margin-top: 12px;
}

.quicklink_v-flex {
    min-height: 100px;
}
</style>
